<template>
  <adminTable :tableLoading="tableLoading" :totalList="totalList" v-model:page="page" v-model:limit="limit"
    v-model:searchForm="searchForm" :tableData="tableData" @search="getList">
    <template v-slot:form-inline-items>
      <el-form-item>
        <el-input v-model="searchForm.username" placeholder="用户名" clearable />
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.phone" placeholder="手机号码" clearable />
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.is_test" placeholder="账号类型" clearable>
          <el-option v-for="item in accountTypeEnums" :label="item.label" :value="item.value" :key="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.type" placeholder="中奖类型" clearable>
          <el-option v-for="item in lottoryTypeBEnums" :label="item.label" :value="item.value" :key="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.deliver_status" placeholder="发货状态" clearable>
          <el-option v-for="item in deliverStatusEnums" :label="item.label" :value="item.value" :key="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-col :span="11">
          <el-date-picker v-model="searchForm.starttime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="开始时间" style="width: 100%" />
        </el-col>
        <el-col :span="2" class="text-center">
          <span class="text-gray-500">-</span>
        </el-col>
        <el-col :span="11">
          <el-date-picker v-model="searchForm.endtime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="结束时间" style="width: 100%" />
        </el-col>
      </el-form-item>
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="username" label="用户名称" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.username }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="手机号码" width="160">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.phone }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="is_test" label="用户类型" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ getLabelByVal(scope.row.is_test, accountTypeEnums) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="raffle_id" label="抽奖id" width="130" />
      <el-table-column prop="raffle_name" label="抽奖产品名称" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.raffle_name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="img" label="奖品图片" width="200">
        <template #default="scope">
          {{ scope.row.img ? "" : "--" }}
          <el-image v-if="scope.row.img" class="previewImg" :preview-teleported="true"
            :src="proxy.IMG_BASE_URL + scope.row.img" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
            :preview-src-list="[proxy.IMG_BASE_URL + scope.row.img]" show-progress :initial-index="0" fit="cover" />
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="数量（价值）" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.amount }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="类型" width="130">
        <template #default="scope">
          {{ scope.row.type == 0 ? '金额' : scope.row.type == 1 ? '积分' : '实物' }}
        </template>
      </el-table-column>
      <el-table-column label="收件人" width="80">
        <template #default="scope">
          {{ scope.row.receive_name }}
        </template>
      </el-table-column>
      <el-table-column label="联系电话" width="130">
        <template #default="scope">
          {{ scope.row.receive_phone }}
        </template>
      </el-table-column>
      <el-table-column label="收货地址" width="130">
        <template #default="scope">
          {{ scope.row.receive_area + scope.row.receive_address }}
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="描述" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.desc }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="create_at" label="创建时间" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.create_at }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="update_at" label="更新时间" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.update_at }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="deliver_status" label="发货状态" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ getLabelByVal(scope.row.deliver_status, deliverStatusEnums) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="200">
        <template #default="scope">
          <el-button type="primary" icon="Edit" :disabled="scope.row.deliver_status != 1" v-permission
            @click="handleDeliver(scope.row)">{{ getLabelByVal(scope.row.deliver_status, deliverStatusEnums)
            }}</el-button>
        </template>
      </el-table-column>
    </template>
    <el-dialog v-model="dialogFlag" title="物流信息" width="450">
      <el-form :model="deliverForm" label-width="80px">
        <el-form-item label="快递公司">
          <el-input v-model="deliverForm.deliver_company" placeholder="请输入快递公司" />
        </el-form-item>
        <el-form-item label="快递单号">
          <el-input v-model="deliverForm.deliver_no" placeholder="请输入快递单号" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="deliverForm.deliver_remark" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="sendGood"> 保存 </el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { useRoute } from 'vue-router'
import { accountTypeEnums, lottoryTypeBEnums, deliverStatusEnums, getLabelByVal } from "../../config/enums";

const route = useRoute()

const searchForm = ref({
  phone: "",
  username: "",
  is_test: "",
  starttime: "",
  endtime: "",
});

onMounted(() => {
  if (route.query && route.query.phone) {
    searchForm.value.phone = route.query.phone
  }
  getList();
});

const { proxy } = getCurrentInstance();

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const tableData = ref([]);

const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    method: "get",
    url: "/Raffle/getRaffleLogLists",
    params: {
      page: page.value,
      limit: limit.value,
      ...searchForm.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};
const dialogFlag = ref(false);
const deliverForm = ref({
  id: "",
  deliver_company: "",
  deliver_no: "",
  deliver_remark: "",
})
const handleDeliver = (row) => {
  deliverForm.value.id = row.id
  dialogFlag.value = true
}
const sendGood = async () => {
  const res = await proxy.$http({
    method: "post",
    url: "/Raffle/deliverPrize",
    data: { ...deliverForm.value }
  });
  if (res.code == 0) {
    proxy.$message.success("发货成功");
    dialogFlag.value = false;
    getList();
  }
};
</script>

<style lang="less" scoped></style>
